import { FC } from "react"

const NoCandidate: FC = () => {
    return (
        <>
            <svg
                className="min-w-50px"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M25 1.15039C38.172 1.15039 48.8496 11.828 48.8496 25C48.8496 38.172 38.172 48.8496 25 48.8496C11.828 48.8496 1.15039 38.172 1.15039 25C1.15039 11.828 11.828 1.15039 25 1.15039Z"
                    fill="white"
                    stroke="#AAAAAA"
                    strokeWidth="2.3"
                />
                <path
                    d="M24.9501 25.1952C27.7034 25.1952 29.9334 22.9651 29.9334 20.2118C29.9334 17.4586 27.7034 15.2285 24.9501 15.2285C22.1968 15.2285 19.9667 17.4586 19.9667 20.2118C19.9667 22.9651 22.1968 25.1952 24.9501 25.1952ZM24.9501 26.441C21.6237 26.441 14.9834 28.1104 14.9834 31.4243V33.916H34.9167V31.4243C34.9167 28.1104 28.2764 26.441 24.9501 26.441Z"
                    fill="#AAAAAA"
                />
            </svg>
        </>
    )
}

export default NoCandidate;